import { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button
} from '@mui/material';
import { colors } from '../../../utils/colors';

const CreateFolderDialog = ({ open, onClose, onFolderCreated, customerId, projectId }) => {
  const [folderName, setFolderName] = useState('');
  const [loading, setLoading] = useState(false);

  const handleCreate = async () => {
    if (!folderName.trim()) return;

    try {
      setLoading(true);
      setFolderName('');
      onFolderCreated();
    } catch (error) {
      console.error('Error creating folder:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    if (!loading) {
      setFolderName('');
      onClose();
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: { xs: 2, sm: 3 },
          p: { xs: 0.5, sm: 1 }
        }
      }}
    >
      <DialogTitle
        sx={{
          fontWeight: 700,
          fontSize: { xs: '1.25rem', sm: '1.5rem' },
          color: colors.text.primary,
          pb: { xs: 1, sm: 2 }
        }}
      >
        New Folder
      </DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label="Folder Name"
          type="text"
          fullWidth
          variant="outlined"
          value={folderName}
          onChange={(e) => setFolderName(e.target.value)}
          placeholder="Enter folder name"
          disabled={loading}
          sx={{
            mt: { xs: 1, sm: 2 },
            '& .MuiOutlinedInput-root': {
              borderRadius: 2
            }
          }}
          onKeyPress={(e) => {
            if (e.key === 'Enter' && folderName.trim()) {
              handleCreate();
            }
          }}
        />
      </DialogContent>
      <DialogActions sx={{ p: { xs: 2, sm: 3 }, pt: { xs: 1.5, sm: 2 } }}>
        <Button
          onClick={handleClose}
          disabled={loading}
          sx={{
            textTransform: 'none',
            color: colors.text.secondary,
            fontWeight: 600,
            fontSize: { xs: '0.875rem', sm: '0.9375rem' }
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={handleCreate}
          variant="contained"
          disabled={!folderName.trim() || loading}
          sx={{
            textTransform: 'none',
            bgcolor: colors.primary.main,
            color: '#fff',
            fontWeight: 600,
            px: { xs: 2.5, sm: 3 },
            fontSize: { xs: '0.875rem', sm: '0.9375rem' },
            '&:hover': {
              bgcolor: colors.primary.dark
            }
          }}
        >
          {loading ? 'Creating...' : 'Create Folder'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreateFolderDialog;
